// Marks the search words in the page reached from a search hit (?highlight=…). mark.js is a chunk of its own, loaded
// only when the parameter is there.
export default function () {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const query = urlParams.get('highlight');
    if (query) {
        import(/* webpackChunkName: "mark" */ 'mark.js').then(({default: Mark}) => {
            let instance = new Mark(document.querySelector("#content"));
            instance.mark(query);
        });
    }

}
